import isBoolean from "lodash/isBoolean";
import isDate from "lodash/isDate";
import isFunction from "lodash/isFunction";
import isInteger from "lodash/isInteger";
import isNull from "lodash/isNull";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import isUndefined from "lodash/isUndefined";

export const jsonMultiparse = (data) => {
    let convertValue = data;
    
    if (convertValue === '') 
        return '';

    try {
      if (
        isInteger(data) ||
        isBoolean(data) ||
        isNull(data) ||
        isUndefined(data) ||
        isDate(data) ||
        isFunction(data)
      ) {
        return data;
      }
  
      if (isString(data) && (data?.includes('{') || data?.includes('['))) {
        try {
          convertValue = JSON.parse(data);
        } catch (e) {
          // convertValue bleibt unverändert, da die Konvertierung fehlgeschlagen ist
        }
      }
      if (isString(convertValue) && ((convertValue?.startsWith('0') && convertValue !== '0' && convertValue !== '0.00') || convertValue?.startsWith('+'))) {
        return convertValue;
      }
      if (isString(convertValue)) {
        if (!isNaN('' + convertValue)) {
          if (('' + convertValue).includes('.') || ('' + convertValue).includes(',')) {
            convertValue = parseFloat(convertValue);
          } else {
            convertValue = parseInt(convertValue);
          }
  
          if (isNaN(convertValue)) {
            if (['null', 'undefined'].includes(data)) {
              convertValue = null;
            } else if (data === 'true') {
              convertValue = true;
            } else if (data === 'false') {
              convertValue = false;
            }
          }
        }
      }
  
      if (isObject(convertValue)) {
        if (Array.isArray(convertValue)) {
          convertValue = convertValue.map(jsonMultiparse);
        } else {
          convertValue = Object.keys(convertValue).reduce((newData, item) => {
            try {
              Object.defineProperty(newData, item, {
                value: jsonMultiparse(convertValue[item]),
                writable: true,
                configurable: true,
                enumerable: true,
              });
            } catch (e) {
              Object.defineProperty(newData, item, {
                value: convertValue[item],
                writable: true,
                configurable: true,
                enumerable: true,
              });
            }
            return newData;
          }, {});
        }
      }
    } catch (e) {
      return data;
    }
  
    return convertValue;
};